import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FAIRE_ACTIONS } from "@faire/retailer-visitor-shared/views/careers/__internal__/BelongingAtFaire/faireActions";
import { DefinitionTerm, EyebrowText, LimitedSectionContent, Section, SectionHeadline } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Row, Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
var BelongingWordsInActionBase = function() {
    var headlineSpace = useResponsiveValue({
        mobileAndAbove: "7x",
        tabletAndAbove: "8x",
        desktopAndAbove: "10x"
    });
    var _useViewport = useViewport(), isDesktopAndAbove = _useViewport.isDesktopAndAbove, isTabletAndBelow = _useViewport.isTabletAndBelow;
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsx(Section, {
        $withHorizontalPadding: true,
        $withVerticalPadding: true,
        align: "center",
        children: /*#__PURE__*/ _jsxs(LimitedSectionContent, {
            children: [
                /*#__PURE__*/ _jsx(EyebrowText, {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "BO9f+b",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Our Words In Action"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "3x"
                }),
                /*#__PURE__*/ _jsx(StyledHeadline, {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "QijPDP",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "How we\u2019re building a culture of belonging"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: headlineSpace
                }),
                /*#__PURE__*/ _jsx(Column, {
                    align: isDesktopAndAbove ? "flex-end" : "flex-start",
                    children: isTabletAndBelow ? renderSingleColumn(strictLocalize) : renderDoubleColumn(strictLocalize)
                })
            ]
        })
    });
};
export var BelongingWordsInAction = observer(BelongingWordsInActionBase);
var renderDoubleColumn = function(strictLocalize) {
    var columnHeight = Math.ceil(FAIRE_ACTIONS.length / 2);
    return /*#__PURE__*/ _jsx(Grid, {
        $rows: columnHeight,
        children: FAIRE_ACTIONS(strictLocalize).map(function(action) {
            return /*#__PURE__*/ _jsx(React.Fragment, {
                children: /*#__PURE__*/ _jsx(CellComponent, {
                    title: action.title,
                    description: action.description,
                    number: action.number
                })
            }, action.title);
        })
    });
};
var renderSingleColumn = function(strictLocalize) {
    return /*#__PURE__*/ _jsx(React.Fragment, {
        children: FAIRE_ACTIONS(strictLocalize).map(function(action, index) {
            return /*#__PURE__*/ _jsxs(React.Fragment, {
                children: [
                    index === 0 ? null : /*#__PURE__*/ _jsx(Spacer, {
                        size: "5x"
                    }),
                    /*#__PURE__*/ _jsx(CellComponent, {
                        title: action.title,
                        description: action.description,
                        number: action.number
                    })
                ]
            }, action.title);
        })
    });
};
var CellComponent = function(param) {
    var title = param.title, description = param.description, number = param.number;
    var isTabletAndAbove = useViewport().isTabletAndAbove;
    return /*#__PURE__*/ _jsx("dl", {
        style: {
            height: "fit-content"
        },
        children: /*#__PURE__*/ _jsxs(Row, {
            align: "flex-start",
            children: [
                isTabletAndAbove && number ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(DefinitionTerm, {
                            children: number
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "2x"
                        })
                    ]
                }) : null,
                /*#__PURE__*/ _jsxs(Column, {
                    children: [
                        /*#__PURE__*/ _jsx(DefinitionTerm, {
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "1x"
                        }),
                        /*#__PURE__*/ _jsx(MaxWidthTypography, {
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
var StyledHeadline = styled(SectionHeadline).withConfig({
    componentId: "sc-6fb1e0dd-0"
})([
    "max-width:",
    ";",
    "{max-width:",
    ";}"
], getSpacing(450), responsiveMediaQueries.tabletAndBelow, getSpacing(346));
var Grid = styled.div.withConfig({
    componentId: "sc-6fb1e0dd-1"
})([
    "display:grid;column-gap:",
    ";grid-template-rows:repeat(",
    ",1fr);grid-auto-flow:column;"
], getSpacing("7x"), function(props) {
    return props.$rows;
});
var MaxWidthTypography = styled(Typography).withConfig({
    componentId: "sc-6fb1e0dd-2"
})([
    "max-width:",
    ";",
    "{max-width:",
    ";}"
], getSpacing(368), responsiveMediaQueries.tabletAndBelow, getSpacing(470));
